export default __webpack_public_path__ + "static/media/card-vertical.b3ec81f3.png";